import { useUserRoles } from '@anytag/auth';
import { Form } from '@anytag/shared-atoms';
import { MarketplaceCampaignDetailType } from '@anytag/graphql';
import { DefaultFormProps } from '../types';
import { getMarketplaceInitialFormValues } from '../utils';
import { Template } from './Template';
import { getUrlTrackingFormSchema } from './schema';

export const URLTrackingForm = ({ data, onSubmit, disabledFields, defaultAdvertiser }: DefaultFormProps) => {
  const { role } = useUserRoles();
  const defaultValues = getMarketplaceInitialFormValues({
    data,
    defaultAdvertiser,
    campaignType: MarketplaceCampaignDetailType.URL_TRACKING
  });

  return (
    <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={getUrlTrackingFormSchema(role)}>
      <Template defaultValues={defaultValues} disabledFields={disabledFields} />
    </Form.Provider>
  );
};
